import React, { useState, useEffect, useRef } from 'react';
import '../catalogue/styles.css';
import img from './catalogue.jpg';
import pptxgen from 'pptxgenjs';
import img2 from './powerpoint.png';
import img3 from './excel.png';
import img4 from './pdfFinal.png';
import s1 from './templates/s1.jpg';
import s2 from './templates/s2.jpg';
import pdf_one from './pptout/pdf_one.jpg';
import pdf_two from './pptout/pdf_two.jpg';
import excel_one from './pptout/excel_one.jpg';
import excel_two from './pptout/excel_two.jpg';
import ppt_one from './pptout/ppt_one.jpg';
import ppt_two from './pptout/ppt_two.jpg';
import ppt_three from './pptout/ppt_three.jpg';
import ppt_four from './pptout/ppt_four.jpg';
import ppt_six from './pptout/ppt_six.png';
import ppt_seven from './pptout/ppt_seven.jpg';
import ppt_eight from './pptout/ppt_eight.jpg';
import ppt_nine from './pptout/ppt_nine.jpg';
import fontImages from './ikae 2.jpg';
import fontImages2 from './ppt .jpg';
import { saveAs } from 'file-saver';
import VisibleIcon from '@rsuite/icons/Visible';
import EditIcon from '@rsuite/icons/Edit';
import ExcelJS from 'exceljs';
import CopyToClipboard from 'react-copy-to-clipboard';
import globalIP from '../../GlobelIP';
import EmailIcon from '@rsuite/icons/Email';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  ButtonGroup,
  Panel,
  Container,
  Modal,
  FlexboxGrid,
  Message,
  Col,
  Drawer,
  Placeholder,
  InputGroup,
  InputNumber,
  Input,
  useToaster,
  Whisper,
  Tooltip
} from 'rsuite';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@rsuite/icons';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import FormControlLabel from 'rsuite/esm/FormControlLabel';

declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: object) => jsPDF;
  }
}
const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const GenerateMarketing = () => {
  const ip = globalIP;
  const [cata, setCata] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const bid = searchParams.get('bid') || '';
  const selectedItemsArray = selectedItems.split(',');
  const bidArray = bid.split(',');
  const [pptObject, setPPTObject] = useState(null);
  const [pptFileObject, setPptFileObject] = useState();
  const [cataexcel, setCataexcel] = useState([]);
  const [slidesexcel, setSlidesexcel] = useState([]);
  const [cataPpt, setCataPpt] = useState([]);
  const [slides, setSlides] = useState([]);
  const [cataPdf, setCataPdf] = useState([]);
  const [slidespdf, setSlidespdf] = useState([]);
  useEffect(() => {
    fetchData123();
    fetchDatabemail();
  }, []);
  useEffect(() => {
    fetchDataexcel();
    fetchDatappt();
    fetchDatapdf();
  }, []);
  const fetchDatappt = async () => {
    const response = await fetch(
      `${ip}/api/temp-lib-emark-ppts?populate=*&filters[Type][$eq]=Regular`
    );
    const json = await response.json();
    setCataPpt(json.data);
    const slides = json.data[0]?.attributes?.Slides;
    setSlides(slides);
  };
  const fetchDataexcel = async () => {
    const response = await fetch(
      `${ip}/api/temp-lib-emark-excels?populate=*&filters[Type][$eq]=Regular`
    );
    const json = await response.json();
    setCataexcel(json.data);
    // console.log(json.data);
    const slides = json.data[0]?.attributes?.Body;
    setSlidesexcel(slides);
  };
  const fetchDatapdf = async () => {
    const response = await fetch(
      `${ip}/api/temp-lib-emark-pdfs?populate=*&filters[Type][$eq]=Regular`
    );
    const json = await response.json();
    setCataPdf(json.data[0]);
    const slides = json.data[0]?.attributes?.Pages;
    setSlidespdf(slides);
  };
  const fetchData123 = async () => {
    const excludeProductCodesFilter = selectedItemsArray
      .map(code => `filters[id][$eq]=${code}`)
      .join('&');
    const apiUrl = `${ip}/api/products?populate=*&${excludeProductCodesFilter}`;
    const response = await fetch(apiUrl);
    const json = await response.json();
    setCata(json.data);
  };

  const toaster = useToaster();

  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    // console.log(imageUrl + 'image');
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });

  const downloadExcelData = async data => {
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];

    const headerMapping = {
      id: 'ID',
      ProductId: 'Alias Code',
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      SizeUnit: 'Unit',
      ProductName: 'Product Name'
      // Add more header mappings as needed
    };

    // Determine if we need to show the banner or company name
    const bannerData = cataexcel[0]?.attributes?.BannerPath?.data?.attributes;
    const isBannerVisible = cataexcel[0]?.attributes?.Banner === 'Yes';
    const companyName = !isBannerVisible
      ? cataexcel[0]?.attributes?.cmpnm || 'Your Company Name'
      : '';
    const bannerUrl = isBannerVisible ? `${ip}${bannerData?.url}` : '';

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });

    if (isBannerVisible) {
      if (bannerUrl) {
        const bannerResponse = await fetch(bannerUrl);
        const bannerImageBuffer = await bannerResponse.arrayBuffer();
        const bannerImageId = workbook.addImage({
          buffer: bannerImageBuffer,
          extension: 'jpg' // Adjust the image format as needed
        });
        worksheet.addImage(bannerImageId, {
          tl: { col: 0, row: 0 },
          ext: { width: 1222, height: 100 }
        });
        worksheet.mergeCells('A1:L4'); // Adjust the merge range as needed
      }
    } else {
      const companyNameRow = worksheet.addRow([]);
      companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      companyNameRow.getCell(1).font = { size: 16, bold: true };
      const companyRow = worksheet.getRow(1);
      companyRow.height = 20;
      worksheet.mergeCells('A1:L3');
      worksheet.getCell('E1').value = companyName;
    }

    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName'
      // ... (other columns)
    ];

    const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerchange);
    const headerRow = worksheet.getRow(4); // Assuming the header is in the 4th row
    headerRow.height = 30; // Adjust the height as needed
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: index % 2 === 0 ? { argb: 'e5e5e5' } : { argb: 'e5e5e5' } // Alternate background colors
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column D
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column E
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column C
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column K
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column L

    // Fetch and embed images
    for (const item of data) {
      const imageUrl = item.Image;
      if (imageUrl) {
        // Fetch the image data
        const response = await fetch(imageUrl);
        const imageBuffer = await response.arrayBuffer();
        // Embed the image in the worksheet
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'png' // Adjust the image format as needed
        });
        const values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null));
        worksheet.addRow(values);
        const rowNumber = worksheet.rowCount;
        worksheet.addImage(imageId, {
          tl: { col: 1.3, row: worksheet.rowCount - 0.2 }, // Adjust the column as needed
          ext: { width: 100, height: 100 } // Adjust the image size as needed
        });

        const row = worksheet.getRow(rowNumber);
        row.height = 100; // Adjust the height as needed

        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          });
        });
      }
    }

    const excelBuffer = await workbook.xlsx.writeBuffer();
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(excelData, 'Catalogue.xlsx');
  };

  const downloadExcelData2 = async data => {
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      id: 'ID',
      ProductId: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      SizeUnit: 'Unit',
      ProductName: 'Product Name'
    };

    // Get company details from cataexcel
    const companyData = cataexcel[0]?.attributes;
    const bannerStatus = companyData?.Banner;
    const companyName =
      bannerStatus === 'Yes'
        ? companyData?.BannerPath?.data?.attributes?.url || 'Your Company Name'
        : 'Your Company Name';
    const logoUrl =
      bannerStatus === 'Yes' ? companyData?.BannerPath?.data?.attributes?.url || '' : ''; // Set logo URL to empty if not using Banner
    const imag = logoUrl ? `${ip}${logoUrl}` : ''; // Build image URL if available

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });

    // Handle company name row or image
    if (bannerStatus === 'Yes' && imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'jpg' // Assuming JPEG format for Banner image
      });

      worksheet.mergeCells('A1:L4');
      worksheet.addImage(logoImageId, { tl: { col: 0, row: 0 }, ext: { width: 1225, height: 88 } }); // Adjust size as needed
    } else {
      const companyNameRow = worksheet.addRow([]);
      companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      companyNameRow.getCell(1).font = { size: 16, bold: true };
      const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
      conpmayRow.height = 20;
      worksheet.mergeCells('A1:L3');
      worksheet.getCell('E1').value = companyName;
    }

    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName'
      // ... (other columns)
    ];

    const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerchange);
    const headerRow = worksheet.getRow(5); // Assuming the header is in the first row
    headerRow.height = 30; // Adjust the height as needed
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium', color: { argb: '00000000' } },
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
    });

    // Adjust column widths as needed
    worksheet.getColumn('B').width = 20;
    worksheet.getColumn('D').width = 30;
    worksheet.getColumn('E').width = 20;
    worksheet.getColumn('C').width = 10;
    worksheet.getColumn('K').width = 20;
    worksheet.getColumn('L').width = 20;

    // Add rows and images
    for (const item of data) {
      const imageUrl = item.Image;
      const response = await fetch(imageUrl);
      const imageBuffer = await response.arrayBuffer();
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: 'png' // Assuming PNG format for product images
      });
      const values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null));
      worksheet.addRow(values);
      worksheet.addImage(imageId, {
        tl: { col: 1.3, row: worksheet.rowCount - 0.5 }, // Adjust the column as needed
        ext: { width: 100, height: 100 } // Adjust the image size as needed
      });
      const rowNumber = worksheet.rowCount;
      const row = worksheet.getRow(rowNumber);
      row.height = 100; // Adjust the height as needed
      row.getCell(2).border = {
        top: { style: 'medium', color: { argb: '00000000' } },
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
      worksheet.eachRow({ includeEmpty: true }, row => {
        row.eachCell(cell => {
          cell.border = {
            top: { style: 'medium', color: { argb: '00000000' } },
            left: { style: 'medium', color: { argb: '00000000' } },
            bottom: { style: 'medium', color: { argb: '00000000' } },
            right: { style: 'medium', color: { argb: '00000000' } }
          };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
      });
    }

    const excelBuffer = await workbook.xlsx.writeBuffer();
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(excelData, 'Catalogue.xlsx');
  };

  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };
  const handleDownloadPPT1 = () => {
    const ppt = new pptxgen();
    const addCoverSlide = coverImageUrl => {
      const slide = ppt.addSlide();
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6
      };
      slide.addImage({ path: coverImageUrl, ...logoOptions });
    };

    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const website = firstItem?.attributes.website || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6,
        fill: '#eff1f0'
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%',
        h: 0.5,
        fill: '#2f7a7c'
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%',
        h: 0.5,
        fill: '#afafaf'
      };
      slide.addShape('rect', headerBackground2);
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: 5.6
        };
        slide.addImage({ path: logoImageUrl, ...logoOptions });
      }
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
    };

    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const slideBackgroundColor = {
        x: 0.15,
        y: 0.1,
        w: '55%',
        h: '95.5%',
        fill: '#E5E4E2'
      };
      slide.addShape('rect', slideBackgroundColor);
      const slideBackgroundColorc = {
        x: 6,
        y: 0.1,
        w: '38%',
        h: '40%',
        fill: '#E5E4E2'
      };
      slide.addShape('rect', slideBackgroundColorc);
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.6,
        y: 0.25,
        w: 4.5,
        h: 5
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 2;
        const imageHeight = 2;
        const xOffset = 6.9;
        const yOffset = 0.2;

        const maxImages = Math.min(1, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset,
            y: yOffset + index * imageHeight * 1.2,
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      const tableRows = [];
      let yOffset = 0.1;

      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('CategoryName' in product.attributes) {
        const productidAttrCell = {
          text: 'Category',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.CategoryName}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const productidAttrCell = {
          text: 'ProductType',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.ProductTypeName}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const productidAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.ProductName}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const productidAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.Description}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const productidAttrCell = {
          text: 'Finish',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.FinishName}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ColorName' in product.attributes) {
        const productidAttrCell = {
          text: 'Color',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.ColorName}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('NetWeight' in product.attributes) {
        const productidAttrCell = {
          text: 'Net Wt.',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.NetWeight}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('GrossWeight' in product.attributes) {
        const productidAttrCell = {
          text: 'Gross Wt.',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${':'}${product.attributes.GrossWeight}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      // Continue adding other attributes similarly...

      const tableOptions = {
        x: 5.9,
        y: 2.4,
        w: '40%',
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: false
      };

      slide.addTable(tableRows, tableOptions);
    };

    const addLastSlide = lastImageUrl => {
      const slide = ppt.addSlide();
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6
      };
      slide.addImage({ path: lastImageUrl, ...logoOptions });
    };

    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    // Add cover slide if applicable
    if (
      cataPpt[0]?.attributes?.CoverSlide === 'Yes' &&
      cataPpt[0]?.attributes?.CSPath?.data?.attributes?.url
    ) {
      const coverImageUrl = `${ip}${cataPpt[0].attributes.CSPath.data.attributes.url}`;
      addCoverSlide(coverImageUrl);
    }

    // Add introduction slide

    // addIntroductionSlide();

    // Add product slides
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Add last slide if applicable
    if (
      cataPpt[0]?.attributes?.LastSlide === 'Yes' &&
      cataPpt[0]?.attributes?.LSPath?.data?.attributes?.url
    ) {
      const lastImageUrl = `${ip}${cataPpt[0].attributes.LSPath.data.attributes.url}`;
      addLastSlide(lastImageUrl);
    }

    setPPTObject(ppt);
    ppt
      .write('base64')
      .then(base64Data => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        });
        const file = new File([blob], 'Catalogue.pptx', {
          type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        });
        setPptFileObject(file);
        const url = URL.createObjectURL(blob);

        // Create a link for download
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Catalogue.pptx';

        link.click();
      })
      .catch(err => {
        console.error(err);
      });
  };

  const handleDownloadPPT8 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addCoverSlide(ppt);

    addIntroductionSlide();
    const addProductSlides = products => {
      const slide = ppt.addSlide();
      let xOffset = 0.7;

      for (const product of products) {
        const imageUrlc = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
        const imageOptionsc = {
          x: xOffset,
          y: 1,
          w: 2.5,
          h: 2.5
        };

        slide.addImage({ path: imageUrlc, ...imageOptionsc });

        // Create a table for the product attributes (similar to your previous code)
        const tableRows = [];
        let yOffset = 0.1;

        if ('ProductId' in product.attributes) {
          const productidAttrCell = {
            text: 'Alias Code',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          const productidValCell = {
            text: `  ${product.attributes.ProductId?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          tableRows.push([
            productidAttrCell,
            { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }

        const tableOptions = {
          x: xOffset,
          y: 4,
          w: 2,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: true
        };

        slide.addTable(tableRows, tableOptions);

        xOffset += 3; // Increment xOffset to position the next product
      }
    };

    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 3);
      addProductSlides(productsOnSlide);
      serialCounter += 3; // Move to the next set of three products
    }
    addLastSlide(ppt);

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };
  const handleDownloadPPT7 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addCoverSlide(ppt);

    addIntroductionSlide();
    const addProductSlides = products => {
      const slide = ppt.addSlide();
      let xOffset = 0.9;

      for (const product of products) {
        const imageUrlc = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
        const imageOptionsc = {
          x: xOffset - 0.4,
          y: 0.2,
          w: 4,
          h: 4
        };
        slide.addShape('rect', {
          x: xOffset - 0.8,
          y: 0.1,
          w: 4.8,
          h: 4.2,
          fill: '#E5E4E2' // Set the background color for the image
        });

        slide.addImage({ path: imageUrlc, ...imageOptionsc });

        // Create a table for the product attributes (similar to your previous code)
        const tableRows = [];
        let yOffset = 0.1;

        if ('ProductId' in product.attributes) {
          const productidAttrCell = {
            text: 'Alias Code',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              bold: true,
              valign: 'middle'
            }
          };
          const productidValCell = {
            text: `${product.attributes.ProductId?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              bold: true,
              valign: 'middle'
            }
          };
          tableRows.push([
            productidAttrCell,
            { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
        if ('Description' in product.attributes) {
          const discAttrCell = {
            text: 'Description',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'top'
            }
          };
          const discValCell = {
            text: `${product.attributes.Description?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          tableRows.push([
            discAttrCell,
            { ...discValCell, options: { ...discValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }

        const tableOptions = {
          x: xOffset - 0.8,
          y: 4.5,
          w: 4.8,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: false
        };

        slide.addTable(tableRows, tableOptions);

        xOffset += 5; // Increment xOffset to position the next product
      }
    };

    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 2);
      addProductSlides(productsOnSlide);
      serialCounter += 2; // Move to the next set of three products
    }
    addLastSlide(ppt);

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT9 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addCoverSlide(ppt);

    addIntroductionSlide();
    const addProductSlides = products => {
      const slide = ppt.addSlide();
      const productWidth = 2.5; // Width of each product
      const productHeight = 2; // Height of each product
      const xOffset = 2;
      const yOffset = 0.2;
      const xGap = 1; // Adjust the horizontal gap between products
      const yGap = 0.5;

      for (let i = 0; i < products.length; i++) {
        const product = products[i];

        const col = i % 2; // 0 or 1 for left or right columns
        const row = Math.floor(i / 2); // 0 or 1 for top or bottom rows

        const x = xOffset + col * (productWidth + xGap);
        const y = yOffset + row * (productHeight + yGap);

        const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
        const imageOptions = {
          x: x,
          y: y,
          w: productWidth,
          h: productHeight
        };

        slide.addImage({ path: imageUrl, ...imageOptions });

        // Create a table for the product attributes (similar to your previous code)
        const tableRows = [];

        if ('ProductId' in product.attributes) {
          const productidAttrCell = {
            text: 'Alias Code',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          const productidValCell = {
            text: `:   ${product.attributes.ProductId?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          tableRows.push([productidAttrCell, productidValCell]);
        }

        const tableOptions = {
          x: x,
          y: y + productHeight + 0.1, // Adjust vertical position for the table
          w: productWidth,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: true
        };

        slide.addTable(tableRows, tableOptions);
      }
    };

    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 4);
      addProductSlides(productsOnSlide);
      serialCounter += 4; // Move to the next set of three products
    }
    addLastSlide(ppt);

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };
  // Helper function to add a cover slide
  const addCoverSlide = ppt => {
    const slide = ppt.addSlide();
    const coverSlideData = cataPpt.find(item => item.attributes.CoverSlide === 'Yes');
    if (coverSlideData && coverSlideData.attributes.CSPath?.data?.attributes?.url) {
      const coverImageUrl = `${ip}${coverSlideData.attributes.CSPath.data.attributes.url}`;
      const coverImageOptions = {
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      };
      slide.addImage({ path: coverImageUrl, ...coverImageOptions });
    }
  };

  // Helper function to add a last slide
  const addLastSlide = ppt => {
    const lastSlideData = cataPpt.find(item => item.attributes.LastSlide === 'Yes');
    if (lastSlideData && lastSlideData.attributes.LSPath?.data?.attributes?.url) {
      const lastImageUrl = `${ip}${lastSlideData.attributes.LSPath.data.attributes.url}`;
      const slide = ppt.addSlide();
      const lastImageOptions = {
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      };
      slide.addImage({ path: lastImageUrl, ...lastImageOptions });
    }
  };
  const handleDownloadPPT5 = () => {
    const ppt = new pptxgen();

    // Helper function to add a cover slide
    const addCoverSlide = () => {
      const slide = ppt.addSlide();
      const coverSlideData = cataPpt.find(item => item.attributes.CoverSlide === 'Yes');
      if (coverSlideData && coverSlideData.attributes.CSPath?.data?.attributes?.url) {
        const coverImageUrl = `${ip}${coverSlideData.attributes.CSPath.data.attributes.url}`;
        const coverImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: coverImageUrl, ...coverImageOptions });
      }
    };

    // Helper function to add a last slide
    const addLastSlide = () => {
      const lastSlideData = cataPpt.find(item => item.attributes.LastSlide === 'Yes');
      if (lastSlideData && lastSlideData.attributes.LSPath?.data?.attributes?.url) {
        const lastImageUrl = `${ip}${lastSlideData.attributes.LSPath.data.attributes.url}`;
        const slide = ppt.addSlide();
        const lastImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: lastImageUrl, ...lastImageOptions });
      }
    };

    // Add the introduction slide
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;

      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6,
        fill: '#eff1f0'
      };
      slide.addShape('rect', headerBackground);

      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%',
        h: 0.5,
        fill: '#2f7a7c'
      };
      slide.addShape('rect', headerBackground1);

      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%',
        h: 0.5,
        fill: '#afafaf'
      };
      slide.addShape('rect', headerBackground2);

      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: 5.6
        };
        slide.addImage({ path: logoImageUrl, ...logoOptions });
      }

      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
    };

    // Add cover slide if required
    addCoverSlide();
    addIntroductionSlide();

    // Helper function to add a slide with the product image and attributes
    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      if (logoImageUrl) {
        const logoOptions = {
          x: 8.5,
          y: 0.3,
          w: 0.8,
          h: 0.2
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.6,
        y: 0.25,
        w: 4.5,
        h: 5
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      const tableRows = [];
      let yOffset = 0.1;

      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `:   ${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `:   ${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `:   ${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const discValCell = {
          text: `:    ${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `:    ${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `:    ${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `:    ${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `:    ${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6.7,
        y: 2.8,
        w: '30%',
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: true
      };

      slide.addTable(tableRows, tableOptions);
    };

    const reversedCata = [...cata].reverse();
    let serialCounter = 1;
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Add last slide if required
    addLastSlide();

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT2 = () => {
    const ppt = new pptxgen();
    // Data for cover slide and last slide
    const { CoverSlide, LastSlide, CSPath, LSPath } = cataPpt[0].attributes;

    // Helper function to add a cover slide if CoverSlide is "Yes"
    const addCoverSlide = () => {
      if (CoverSlide === 'Yes' && CSPath?.data?.attributes?.url) {
        const slide = ppt.addSlide();
        const coverImageUrl = `${ip}${CSPath.data.attributes.url}`;
        const coverImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: coverImageUrl, ...coverImageOptions });
      }
    };

    // Helper function to add a last slide if LastSlide is "Yes"
    const addLastSlide = () => {
      if (LastSlide === 'Yes' && LSPath?.data?.attributes?.url) {
        const slide = ppt.addSlide();
        const lastSlideImageUrl = `${ip}${LSPath.data.attributes.url}`;
        const lastSlideImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: lastSlideImageUrl, ...lastSlideImageOptions });
      }
    };

    // Add cover slide if applicable
    addCoverSlide();

    // Add introduction slide
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const website = firstItem?.attributes.website || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6,
        fill: '#eff1f0'
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%',
        h: 0.5,
        fill: '#2f7a7c'
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%',
        h: 0.5,
        fill: '#afafaf'
      };
      slide.addShape('rect', headerBackground2);
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: 5.6
        };
        slide.addImage({ path: logoImageUrl, ...logoOptions });
      }
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
    };

    // addIntroductionSlide();

    // Helper function to add a slide for each product
    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.6,
        y: 0.8,
        w: 4,
        h: 4
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      const tableRows = [];
      let yOffset = 0.1;

      if ('CategoryName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Category Name',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductId' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Finish',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ColorName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Color',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.ColorName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('NetWeight' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Net Wt.',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('GrossWeight' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Gross Wt.',
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.GrossWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      // Add other attributes similarly...

      const tableOptions = {
        x: 6,
        y: 0.8,
        w: '30%',
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: false
      };

      slide.addTable(tableRows, tableOptions);
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 10,
              fontFace: 'Arial',
              color: '#000',
              align: 'left',
              valign: 'middle'
            }
          }
        ],
        { x: 9, y: 5.25 }
      );
      const lineOptionsnot = {
        x: 9,
        y: 0,
        w: '5%',
        h: 0.6,
        fill: '#d6d1cd'
      };
      slide.addShape('rect', lineOptionsnot);

      const lineOptionsnob = {
        x: 0.6,
        y: 5.03,
        w: '5%',
        h: 0.6,
        fill: '#d6d1cd'
      };
      slide.addShape('rect', lineOptionsnob);
    };

    const reversedCata = [...cata].reverse();
    let serialCounter = 1;
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Add last slide if applicable
    addLastSlide();

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT3 = () => {
    const ppt = new pptxgen();

    // Helper function to add a cover slide if needed
    const addCoverSlide = () => {
      const coverItem = cataPpt.find(item => item.attributes.CoverSlide === 'Yes');
      if (coverItem) {
        const slide = ppt.addSlide();
        const coverImageUrl = `${ip}${coverItem.attributes.CSPath.data.attributes.url}`;
        const coverImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: coverImageUrl, ...coverImageOptions });
        // Optionally add text or other elements to the cover slide
      }
    };

    // Helper function to add a last slide if needed
    const addLastSlide = () => {
      const lastSlideItem = cataPpt.find(item => item.attributes.LastSlide === 'Yes');
      if (lastSlideItem) {
        const slide = ppt.addSlide();
        const lastImageUrl = `${ip}${lastSlideItem.attributes.LSPath.data.attributes.url}`;
        const lastImageOptions = {
          x: 0,
          y: 0,
          w: '100%',
          h: '100%'
        };
        slide.addImage({ path: lastImageUrl, ...lastImageOptions });
        // Optionally add text or other elements to the last slide
      }
    };

    // Add cover slide if applicable
    addCoverSlide();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1.2, // Adjust the x-coordinate of the logo
          y: 0.6, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.3 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };

    addIntroductionSlide();

    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const headerBackground1 = {
        x: 0.3,
        y: 0.5,
        w: '10%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground = {
        x: 1.4,
        y: 0.5,
        w: '80%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground);

      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: 4, // Adjust the width of the image as needed
        h: 4 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if ('CategoryName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Category Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: ` ${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: ` ${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const discValCell = {
          text: ` ${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      // Add the combined size row if a valid sizeValue is available
      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: ` ${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#E5E4E2',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: ` ${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            fill: '#afafaf',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6,
        y: 1.3,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 10,
              fontFace: 'Arial',
              color: '#ffffff',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 0.65 } // Adjust the position as needed
      );
    };

    const reversedCata = [...cata].reverse();
    let serialCounter = 1;
    // Loop through each item in cata and add a slide for each product
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Add last slide if applicable
    addLastSlide();

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT6 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = fontImages2;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: '100%' // Adjust the height of the logo
        };
        const logoFullPath = fontImages2;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 0 - 1, y: 2.5, align: 'center' }
      );
      slide.addText(address, {
        x: 0 - 1,
        y: 3,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addCoverSlide(ppt);
    addIntroductionSlide();
    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      const backgroundColor = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height spans the entire slide
        fill: '#f4f6f5' // Replace 'yourColorCode' with your desired background color
      };
      slide.addShape('rect', backgroundColor);
      const squareColor = {
        x: 0, // X-coordinate for the square
        y: 0, // Y-coordinate for the square
        w: 0.5, // Width of the square
        h: 0.5, // Height of the square
        fill: '#ddd0bd' // Replace 'yourSquareColor' with your desired square color
      };
      slide.addShape('rect', squareColor);
      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if ('CategoryName' in product.attributes) {
        const categoryNameAttrCell = {
          text: 'Category Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: ` ${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: ` ${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const discValCell = {
          text: ` ${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      // Add the combined size row if a valid sizeValue is available
      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: ` ${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: ` ${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: {
            fontSize: 10,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: ` ${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Times New Roman',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 0.8,
        y: 1,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 5.4,
        y: 0.7,
        w: 4, // Adjust the width of the image as needed
        h: 4 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 12,
              fontFace: 'Arial',
              color: '#000000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 5.3 } // Adjust the position as needed
      );
    };
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;
    // Loop through each item in cata and add a slide for each product
    reversedCata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });
    addLastSlide(ppt);
    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const handleDownloadPPT4 = () => {
    const ppt = new pptxgen();

    // Helper function to add the cover slide if needed
    const addCoverSlide = () => {
      const coverSlide = cataPpt.find(item => item.attributes.CoverSlide === 'Yes');
      if (coverSlide && coverSlide.attributes.CSPath?.data?.attributes?.url) {
        const slide = ppt.addSlide();
        const coverImageUrl = `${ip}${coverSlide.attributes.CSPath.data.attributes.url}`;
        slide.addImage({
          path: coverImageUrl,
          x: 0, // Adjust as needed
          y: 0, // Adjust as needed
          w: '100%', // Adjust as needed
          h: '100%' // Adjust as needed
        });
      }
    };

    // Helper function to add the last slide if needed
    const addLastSlide = () => {
      const lastSlide = cataPpt.find(item => item.attributes.LastSlide === 'Yes');
      if (lastSlide && lastSlide.attributes.LSPath?.data?.attributes?.url) {
        const slide = ppt.addSlide();
        const lastImageUrl = `${ip}${lastSlide.attributes.LSPath.data.attributes.url}`;
        slide.addImage({
          path: lastImageUrl,
          x: 0, // Adjust as needed
          y: 0, // Adjust as needed
          w: '100%', // Adjust as needed
          h: '100%' // Adjust as needed
        });
      }
    };

    // Add the cover slide if applicable
    addCoverSlide();

    // Add the introduction slide
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 3.2, // Adjust the x-coordinate of the logo
          y: 0.5, // Adjust the y-coordinate of the logo
          w: 4, // Adjust the width of the logo
          h: 1 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 2, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(email, {
        x: 1.4,
        y: 2.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 1.4,
        y: 3.1,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
    };
    addIntroductionSlide();

    // Helper function to add a product slide
    const addProductSlide = product => {
      const slide = ppt.addSlide();

      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 0.5, align: 'center' }
      );

      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1, // Adjust the x-coordinate of the logo
          y: 0.4, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: 3, // Adjust the width of the image as needed
        h: 3 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      // Add the product attributes as a table
      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 1.8; // Adjust the width of each image
        const imageHeight = 1.8; // Adjust the height of each image
        const xOffset = 6; // Adjust the x-offset of the images
        const yOffset = 1.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(2, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      const tableRows = [];

      if ('ProductId' in product.attributes) {
        const productIdAttrCell = {
          text: 'Alias Code',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
        };
        const productIdValCell = {
          text: product.attributes.ProductId?.toString() || '',
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        const yOffset = 7; // Adjust the y-coordinate as needed
        const productIdOptions = { ...productIdValCell.options, y: yOffset };
        tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
      }

      // ... (continue adding other attributes to the table)

      const tableOptions = {
        x: 0.5,
        y: 4.8,
        w: '20%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };

    // Loop through each item in cata and add a slide for each product
    const reversedCata = [...cata].reverse();
    reversedCata.forEach(item => {
      addProductSlide(item);
    });

    // Add the last slide if applicable
    addLastSlide();

    // Download the PPT file
    ppt.writeFile({ fileName: 'Catalogue.pptx' });
  };

  const generatePDF = data => {
    const doc = new jsPDF('landscape');

    // Define table properties
    const startX = 10;
    const startY = 10;
    const cellWidth = 30;
    const cellHeight = 20;
    const headerCellHeight = 10;
    const tableLineWidth = 0.1;

    const attributeDisplayNames = {
      ProductId: 'Alias Code',
      CoverImage: 'Photo',
      Description: 'Description',
      ProductName: 'Product Name',
      ProductTypeName: 'Product Type',
      Dimension: 'Dimension',
      FinishName: 'Finish/Color',
      ProductCost: 'Price',
      NetWeight: 'Net. Wt.'
      // ... (add other mappings as needed)
    };

    // Set the font style for the header cells
    const headerCellBackgroundColor = '#fcff2b';

    // Extract company details from data1
    const cmpnam = data1.map(item => item.attributes.cmpnm);
    const address = data1.map(item => item.attributes.address);
    const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
    const img = `${ip}${logoUrl}`;

    // Define the box properties for the logo
    const logoWidth = 20; // Adjust the logo width as needed
    const logoHeight = 10; // Adjust the logo height as needed
    const logoX = startX + 10; // Adjust the X position as needed
    const logoY = startY + 3; // Adjust the Y position as needed

    // Add the cover page if CoverPage is "Yes"
    if (cataPdf.attributes.CoverPage === 'Yes') {
      const coverImageUrl = `${ip}${cataPdf.attributes.CPPath.data.attributes.url}`;
      doc.addImage(
        coverImageUrl,
        'JPEG',
        0,
        0,
        doc.internal.pageSize.width,
        doc.internal.pageSize.height
      );
      doc.addPage(); // Add a new page for the actual content
    }

    // Add the logo to the PDF
    doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

    // Define the box properties
    const boxWidth = 270; // Adjust the box width as needed
    const boxHeight = 20; // Adjust the box height as needed
    const boxX = startX;
    const boxY = startY;
    const boxText = cmpnam.length > 0 ? cmpnam[0] : 'Company Name'; // Replace with your desired title

    // Add the box with a border
    doc.setLineWidth(tableLineWidth);
    doc.rect(boxX, boxY, boxWidth, boxHeight);

    // Set the font style for the title text and align it to the center
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    const textWidth = doc.getStringUnitWidth(boxText) * doc.internal.scaleFactor;
    const textX = boxX + (boxWidth - textWidth) / 2;
    const textY = boxY + boxHeight / 3;
    doc.text(boxText, textX, textY);

    const addressText = address.length > 0 ? address[0] : 'Address'; // Use the provided address or a default
    const addressTextWidth = doc.getStringUnitWidth(addressText) * doc.internal.scaleFactor;
    const addressTextX = boxX + (boxWidth - addressTextWidth) / 2;
    const addressTextY = boxY + boxHeight / 2;
    doc.text(addressText, addressTextX, addressTextY);

    const addNewPageIfNecessary = currentY => {
      if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        return 10; // Start from the top of the new page
      }
      return currentY;
    };

    // Add header cells
    let currentX = startX;
    let currentY = boxY + boxHeight; // Adjust the vertical position

    Object.keys(attributeDisplayNames).forEach(key => {
      doc.setLineWidth(tableLineWidth);

      doc.setFillColor(headerCellBackgroundColor);
      doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'F');
      doc.setTextColor(0, 0, 0);

      doc.setLineWidth(tableLineWidth);
      doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'S');

      const text = attributeDisplayNames[key];
      const textWidth = doc.getStringUnitWidth(text) * doc.internal.scaleFactor; // Calculate text width
      const textX = currentX + (cellWidth - textWidth) / 2; // Calculate center-aligned x-coordinate
      doc.text(text, textX, currentY + 7);

      currentX += cellWidth;
    });

    // Reset the font style for data cells
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');

    const maxDescriptionLength = 20;

    // Add data cells
    currentY += headerCellHeight;
    data.forEach(product => {
      currentY = addNewPageIfNecessary(currentY);
      currentX = startX;

      Object.keys(attributeDisplayNames).forEach(key => {
        const value = product.attributes[key];
        if (key === 'Description') {
          // Handle Description cell with character limit
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');

          const descriptionText = value?.toString() || '';
          const descriptionLines = [];

          for (let i = 0; i < descriptionText.length; i += maxDescriptionLength) {
            const descriptionLine = descriptionText.slice(i, i + maxDescriptionLength);
            descriptionLines.push(descriptionLine);
          }
          descriptionLines.splice(5); // Remove lines beyond the first 5
          let textY = currentY + 3;
          descriptionLines.forEach(line => {
            doc.text(line, currentX + 1, textY);
            textY += 4; // Adjust line spacing as needed
          });
        } else if (key === 'ProductName') {
          // Handle ProductName cell with character limit
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');

          const descriptionText = value?.toString() || '';
          const descriptionLines = [];

          for (let i = 0; i < descriptionText.length; i += maxDescriptionLength) {
            const descriptionLine = descriptionText.slice(i, i + maxDescriptionLength);
            descriptionLines.push(descriptionLine);
          }
          descriptionLines.splice(5); // Remove lines beyond the first 5
          let textY = currentY + 4;
          descriptionLines.forEach(line => {
            doc.text(line, currentX + 1, textY);
            textY += 4; // Adjust line spacing as needed
          });
        } else if (key === 'Dimension') {
          // Handle Dimension cell
          const dimensionString = `${product?.attributes?.Length || '0'}x${
            product?.attributes?.Width || '0'
          }x${product?.attributes?.Height || '0'} ${product?.attributes?.SizeUnit || 'cm'}`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');
          doc.text(dimensionString, currentX + 2, currentY + 7);
        } else if (key === 'FinishName') {
          const dimensionString = `${product?.attributes?.FinishName || 'Finish'}/${
            product?.attributes?.ColorName || 'Color'
          }`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');
          doc.text(dimensionString, currentX + 2, currentY + 7);
        } else if (key === 'CoverImage') {
          // Handle CoverImage separately to add the image
          const imageX = currentX + 4;
          const imageY = currentY + 2;
          const imageWidth = cellWidth - 8; // Adjust the width as needed
          const imageHeight = cellHeight - 4; // Adjust the height as needed

          if (value) {
            const imageSrc = `${ip}${value.data.attributes.url}`;
            doc.addImage(imageSrc, 'JPEG', imageX, imageY, imageWidth, imageHeight);
            doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');
          }
        } else {
          // Draw regular data cells
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth, cellHeight, 'S');
          const text = value?.toString() || '';
          const textWidth = doc.getStringUnitWidth(text) * doc.internal.scaleFactor; // Calculate text width
          const textX = currentX + (cellWidth - textWidth) / 2; // Calculate center-aligned x-coordinate
          doc.text(text, textX, currentY + 7);
        }

        currentX += cellWidth;
      });

      currentY += cellHeight;
    });

    // Add the last page if LastPage is "Yes"
    if (cataPdf.attributes.LastPage === 'Yes') {
      const lastPageImageUrl = `${ip}${cataPdf.attributes.LPPath.data.attributes.url}`;
      doc.addPage(); // Add a new page for the last page
      doc.addImage(
        lastPageImageUrl,
        'JPEG',
        0,
        0,
        doc.internal.pageSize.width,
        doc.internal.pageSize.height
      );
    }

    return doc;
  };

  const handleDownloadPDF = async () => {
    try {
      const doc = generatePDF(cata);

      // Save the PDF
      doc.save('Catalogue.pdf');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const generatePDF2 = data => {
    const doc = new jsPDF('portrait');

    // Extract company details from data1
    const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
    const img = `${ip}${logoUrl}`;

    // Define the box properties for the logo
    const logoWidth = 25; // Adjust the logo width as needed
    const logoHeight = 10; // Adjust the logo height as needed
    const logoX = 10; // Adjust the X position as needed
    const logoY = 10; // Adjust the Y position as needed

    // Define table properties
    const startX = 10;
    const startY = 30; // Adjusted to ensure there's space for the logo
    const cellWidth = 100;
    const cellHeight = 10; // Decreased table cell height
    const fontSize = 10; // Decreased font size
    const tableLineWidth = 0.1;

    const attributeDisplayNames = {
      ProductId: 'Alias Code',
      Description: 'Description',
      ProductName: 'Product Name',
      ProductTypeName: 'Product Type',
      Dimension: 'Dimension',
      FinishName: 'Finish/Color',
      ProductCost: 'Price',
      NetWeight: 'Net. Wt.'
    };

    // Function to add a new page when necessary
    const addNewPageIfNecessary = currentY => {
      if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        return 10; // Start from the top of the new page
      }
      return currentY;
    };

    // Function to display product data
    const displayProduct = (product, currentX, currentY) => {
      // Large image on the left side
      const value = product.attributes.CoverImage;
      const imageX = currentX + 4;
      const imageY = currentY;
      const imageWidth = cellWidth - 8;
      const imageHeight = 80; // Adjust image height as needed
      doc.setDrawColor(0); // Set border color
      doc.setLineWidth(1); // Set border width
      doc.rect(imageX, imageY, imageWidth, imageHeight);
      if (value) {
        const imageSrc = `${ip}${value.data.attributes.url}`;
        doc.addImage(imageSrc, 'JPEG', imageX, imageY, imageWidth, imageHeight);
      }

      // Right side with attribute names and values
      currentX += 100; // Adjust horizontal position
      doc.setFontSize(fontSize); // Set the font size

      Object.keys(attributeDisplayNames).forEach(key => {
        const attributeLabel = attributeDisplayNames[key];
        const attributeValue = product.attributes[key] || '';

        // Draw border for each cell
        doc.setLineWidth(tableLineWidth);
        doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');

        // Draw lines between attribute and value
        const lineX = currentX + cellWidth / 3.1;
        const lineY1 = currentY;
        const lineY2 = currentY + cellHeight;
        doc.line(lineX, lineY1, lineX, lineY2);

        // Display attribute label and value
        doc.text(attributeLabel, currentX + 2, currentY + 7);

        if (key === 'Description') {
          const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
          const displayedDescription = descriptionLines.slice(0, 2).join('\n');

          doc.text(displayedDescription, currentX + 33, currentY + 4);
          // Display the description text in multiple lines within the cell

          if (descriptionLines.length > 2) {
            // If there are more than 2 lines, add an indicator
            doc.text('.', currentX + 33, currentY + 4 + 7); // Adjust vertical position as needed
          }
        } else if (key === 'ProductName') {
          const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
          const displayedDescription = descriptionLines.slice(0, 2).join('\n');

          doc.text(displayedDescription, currentX + 33, currentY + 4);
          // Display the description text in multiple lines within the cell

          if (descriptionLines.length > 2) {
            // If there are more than 2 lines, add an indicator
            doc.text('.', currentX + 33, currentY + 4 + 7); // Adjust vertical position as needed
          }
        } else if (key === 'Dimension') {
          // Handle Dimension cell
          const dimensionString = `${product?.attributes?.Length || '0'} x ${
            product?.attributes?.Width || '0'
          } x ${product?.attributes?.Height || '0'}`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(dimensionString, currentX + 34, currentY + 7);
        } else if (key === 'FinishName') {
          // Handle FinishName cell
          const dimensionString = `${product?.attributes?.FinishName || 'Finish'} / ${
            product?.attributes?.ColorName || 'Color'
          }`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(dimensionString, currentX + 34, currentY + 7);
        } else {
          doc.text(attributeValue.toString(), currentX + cellWidth / 3, currentY + 7);
        }

        currentY += cellHeight; // Adjust vertical position
      });

      // Add a gap between products
      return currentY + 10; // Adjust the gap as needed
    };

    // Add the cover page if CoverPage is "Yes"
    if (cataPdf.attributes.CoverPage === 'Yes') {
      const coverImageUrl = `${ip}${cataPdf.attributes.CPPath.data.attributes.url}`;
      doc.addImage(
        coverImageUrl,
        'JPEG',
        0,
        0,
        doc.internal.pageSize.width,
        doc.internal.pageSize.height
      );
      doc.addPage(); // Add a new page for the actual content
    }

    // Add the logo to the PDF
    doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

    // Add data in a top-to-down format
    let currentX = startX;
    let currentY = startY;

    data.forEach(product => {
      currentY = addNewPageIfNecessary(currentY);
      currentY = displayProduct(product, currentX, currentY);
    });

    // Add the last page if LastPage is "Yes"
    if (cataPdf.attributes.LastPage === 'Yes') {
      const lastPageImageUrl = `${ip}${cataPdf.attributes.LPPath.data.attributes.url}`;
      doc.addPage(); // Add a new page for the last page
      doc.addImage(
        lastPageImageUrl,
        'JPEG',
        0,
        0,
        doc.internal.pageSize.width,
        doc.internal.pageSize.height
      );
    }

    return doc;
  };

  const handleDownloadPDF2 = async () => {
    try {
      const doc = generatePDF2(cata);

      // Save the PDF
      doc.save('Catalogue.pdf');
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  // const [value, setValue] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const handleOpen = key => {
    // console.log(slides);

    if (slides.length === 1) {
      const tempName = slides[0]?.TempName;

      switch (tempName) {
        case 'Format F1':
          handleDownloadPPT1();
          break;
        case 'Format F2':
          handleDownloadPPT2();
          break;
        case 'Format F3':
          handleDownloadPPT3();
          break;
        case 'Format F4':
          handleDownloadPPT4();
          break;
        case 'Format F5':
          handleDownloadPPT5();
          break;
        case 'Format F6':
          handleDownloadPPT6();
          break;
        case 'Format Two F1':
          handleDownloadPPT7();
          break;
        case 'Format Three F1':
          handleDownloadPPT8();
          break;
        case 'Format Four F1':
          handleDownloadPPT9();
          break;
        default:
          console.warn('No handler for the specified TempName');
      }

      return 1;
    }

    setOpen(true);
  };
  // function handleCountChange() {
  //   if (value === 1) {
  //     setValue(2);
  //   } else if (value === 2) {
  //     setValue(3);
  //   } else if (value === 3) {
  //     setValue(4);
  //   } else {
  //     setValue(1);
  //   }
  // }

  const [valuep, setValuep] = React.useState(1);
  const [openp, setOpenp] = React.useState(false);
  const handleOpenp = key => {
    // console.log(slidespdf);
    if (slidespdf.length == 1) {
      slidespdf[0]?.TempName == 'Format F1' ? handleDownloadPDF() : '';
      slidespdf[0]?.TempName == 'Format F2' ? handleDownloadPDF2() : '';
      return 1;
    }

    setOpenp(true);
  };
  function handleCountChangep() {
    if (valuep === 1) {
      setValuep(2);
    } else if (valuep === 2) {
      setValuep(3);
    } else {
      setValuep(1);
    }
  }
  const handleClosep = () => setOpenp(false);

  ///////////////Excel Modal///////////////
  const [valuee, setValuee] = React.useState(1);
  const [showModalexcel, setShowModalexcel] = useState(false);
  const [selectedRowDataexcel, setSelectedRowDataexcel] = useState(null);
  const handleDownloadexcel = csvData => {
    if (slidesexcel.length == 1) {
      setOpenexcel(false);
      slidesexcel[0]?.TempName == 'Format F1' ? downloadExcelData(csvData) : '';
      slidesexcel[0]?.TempName == 'Format F2' ? downloadExcelData2(csvData) : '';
      return 1;
    }
    setSelectedRowDataexcel(csvData);
    setOpenexcel(true);
    setShowModalexcel(true);
  };
  function handleCountChangee() {
    if (valuee === 1) {
      setValuee(2);
    } else if (valuee === 2) {
      setValuee(3);
    } else {
      setValuee(1);
    }
  }
  const [openexcel, setOpenexcel] = useState(false);
  const handleCloseexcel = () => setOpenexcel(false);

  //// copy link
  const [textToCopy, setTextToCopy] = useState('http://192.168.1.23:3100/catalogue/link');
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    setIsCopied(true);
    // You can add additional handling or feedback here.
  };
  //// copy link

  const [openEmail, setOpenEmail] = useState(false);
  const handleOpenEmail = () => setOpenEmail(true);
  const handleCloseEmail = () => setOpenEmail(false);
  /// Email system start
  const [to, setTo] = useState([]);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [loading, setLoading] = useState(false);
  // const sendemail = async () => {
  //   const endpoint = `${ip}/api/email`;
  //   // skspiyush18198@gmail.com
  //   try {
  //     setLoading(true);
  //     let name = pptFileObject?.name;
  //     let content = await readFileAsBase64(pptFileObject);
  //     console.log(name, content);

  //     for (const recipient of to) {
  //       const data = {

  //         to: recipient,
  //         subject: subject,
  //         html: message,
  //         attachments: [
  //           {
  //             filename: name || '',
  //             content: content || '',
  //             encoding: 'base64'
  //           }
  //         ]
  //       };

  //       const response = await fetch(endpoint, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(data)
  //       });
  //       setLoading(false); // Reset loading state, whether success or failure
  //       handleCloseEmail();
  //       if (response.ok) {
  //         console.log(`Email sent successfully to ${recipient}`);
  //       } else {
  //         console.error(`Failed to send email to ${recipient}`);
  //       }
  //     }

  //     // Notify user after all emails have been sent
  //     console.log('All emails sent successfully!');
  //     toaster.push(
  //       <Message showIcon type="success">
  //         All emails sent successfully!
  //       </Message>,
  //       { placement: 'topEnd' }
  //     );
  //   } catch (error) {
  //     console.error('Error:', error);
  //     toaster.push(
  //       <Message showIcon type="error">
  //         Failed to send email
  //       </Message>,
  //       { placement: 'topEnd' }
  //     );
  //   }
  // };

  /// Email system end

    const sendemail = async () => {
    const endpoint = `${ip}/api/send-mail`;

    try {
      setLoading(true);

      // ✅ Ensure `to` is always an array
      const recipients = Array.isArray(to) ? to : [to];

      // Convert PPT file to Base64
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(",")[1]); // remove "data:...base64,"
          reader.onerror = (error) => reject(error);
        });

      const base64File = pptFileObject ? await toBase64(pptFileObject) : null;

      for (const recipient of recipients) {
        const emailAddress = typeof recipient === "string" ? recipient.trim() : recipient?.email;

        const payload = {
          toEmail: emailAddress,
          subject: subject || "No Subject",
          message: message || "No message provided.",
          htmlTemplate: `<p>${message || "No message provided."}</p>`,
          attachments: base64File
            ? [
                {
                  filename: pptFileObject?.name || "Catalogue.pptx",
                  contentType: pptFileObject?.type || "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                  base64: base64File,
                },
              ]
            : [],
        };

        // console.log("📤 Sending to:", payload);

        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          console.log(`✅ Email sent successfully to ${emailAddress}`);
        } else {
          console.error(`❌ Failed to send email to ${emailAddress}`);
        }
      }

      // Stop loading and close modal after all sends
      setLoading(false);
      handleCloseEmail();

      toaster.push(
        <Message showIcon type="success">All emails sent successfully!</Message>,
        { placement: "topEnd" }
      );

    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      toaster.push(
        <Message showIcon type="error">Failed to send email</Message>,
        { placement: "topEnd" }
      );
    }
  };

  // const sendemail = async () => {
  //   const response = await fetch(`${ip}/api/send-mail`, {
  //     method: 'POST',

  //     headers: { 'Content-Type': 'application/json' },

  //     body: JSON.stringify({
  //       toEmail: 'neerajc811@gmail.com',

  //       subject: 'Test Email via React & Strapi',

  //       message: 'This is a test email sent through Strapi backend.'
  //     })
  //   });

  //   const data = await response.json();

  //   console.log(data);

  //   if (data.success) alert('✅ Email sent successfully!');
  //   else alert('❌ Email failed.');
  // };

  const fetchDatabemail = async () => {
    const excludeProductCodesFilter = bidArray.map(code => `filters[id][$eq]=${code}`).join('&');
    const apiUrl = `${ip}/api/buyer-details?populate=*&${excludeProductCodesFilter}`;
    const response = await fetch(apiUrl);
    const json = await response.json();
    // Flatten the array of arrays to a single array
    const emails = json.data.flatMap(buyerDetail => buyerDetail.attributes.email);

    setTo(emails);
  };

  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <h3 className="title">Catalogue is here</h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Catalogue </Breadcrumb.Item>
            </Breadcrumb>
          </Stack>

          {isCopied ? <Message type="success">Copied!</Message> : null}
        </Stack>
        {/* <Button onClick={handlerefresh} > refresh </Button> */}
        <Divider className="divide" />
        <Stack direction="column" alignItems="center" spacing={30}>
          <Whisper speaker={<Tooltip>Click to send Email</Tooltip>}>
            <Icon
              as={EmailIcon}
              style={{ fontSize: '8rem', cursor: 'pointer' }}
              onClick={() => {
                handleOpenEmail();
                // handleDownloadPPT1();
              }}
            />
          </Whisper>
          <ButtonGroup
            style={{
              marginTop: 50,
              marginBottom: 150,
              width: 700,
              gap: 20,
              justifyContent: 'center',
              textAlign: 'center'
            }}
            justified
          >
            <Stack direction="column" spacing={10}>
              <img
                src={img2}
                style={{ width: '50%', cursor: 'pointer' }}
                onClick={() => handleOpen('right')}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>
            <div></div>
            <Stack direction="column" spacing={10}>
              <img
                src={img3}
                style={{ width: '50%', cursor: 'pointer' }}
                onClick={() => handleDownloadexcel(csvData)}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>

            <Stack direction="column" spacing={10}>
              <img
                src={img4}
                style={{ width: '50%', cursor: 'pointer', borderRadius: '8px' }}
                onClick={() => handleOpenp('lg')}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>
          </ButtonGroup>

          <Form.ControlLabel>
            <b>You can download Outputs of catalogues </b>
          </Form.ControlLabel>
          {/* <Form.ControlLabel>We will update you whenever the buyer opens the catalogue link, shortlists, products or share any queries</Form.ControlLabel> */}
          {/* <Panel bordered>
            <Stack spacing={90}>
              <Input value={textToCopy} readOnly style={{ width: '140%' }} />
              <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
                <Button appearance="primary" color="cyan">
                  Copy Link
                </Button>
              </CopyToClipboard>
            </Stack>
          </Panel> */}
          {/* <CustomButtonGroup /> */}
        </Stack>
      </Container>
      <Modal open={openEmail} onClose={handleCloseEmail} backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <b>Email</b>{' '}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center' }}>
          <Panel style={{ width: '60%', margin: 'auto' }}>
            <Form>
              <FormControlLabel>To:</FormControlLabel>
              <Input value={to} onChange={value => setTo(value)} />
              <FormControlLabel>Subject</FormControlLabel>
              <Input value={subject} onChange={value => setSubject(value)} />
              <FormControlLabel>Body</FormControlLabel>
              <Form.Control
                rows={5}
                name="textarea"
                accepter={Textarea}
                value={message}
                onChange={value => setMessage(value)}
              />
              <input
                type="file"
                ref={inputRef => {
                  if (inputRef && pptObject) {
                    const file = new File([pptObject], 'Catalogue.pptx', {
                      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                    });
                    const fileList = new DataTransfer();
                    fileList.items.add(file);
                    inputRef.files = fileList.files;
                  }
                }}
                style={{ opacity: 1 }}
                onChange={e => console.log(e.target.files[0])}
              />
              {/* const file = new File([ppt], 'Catalogue.pptx', { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }); */}
            </Form>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseEmail} appearance="subtle" active>
            Cancel
          </Button>
          <Button onClick={sendemail} appearance="primary" color="cyan" loading={loading}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ////////Excel modal////////// */}
      {showModalexcel && (
        <Drawer size="xs" open={openexcel} onClose={handleCloseexcel} backdrop="static">
          <Drawer.Header>
            <Drawer.Title>
              <b>Choose the desired format : </b>
            </Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <FlexboxGrid justify="space-around">
              {slidesexcel.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData(selectedRowDataexcel);
                    }}
                    style={{ display: 'flex' }}
                    className="pdf-layout"
                  >
                    <figure>
                      <img src={excel_one} style={{ width: '88%' }} />
                      <figcaption>Format F1</figcaption>
                    </figure>
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slidesexcel.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      downloadExcelData2(selectedRowDataexcel);
                    }}
                    style={{ display: 'flex' }}
                    className="pdf-layout"
                  >
                    <figure>
                      <img src={excel_two} style={{ width: '75%' }} />
                      <figcaption>Format F2</figcaption>
                    </figure>
                    <p></p>
                  </Button>
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
            {/* <Panel>
              {valuee === 1 ? (
                <FlexboxGrid justify="space-around">
                  <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                    <Button
                      block
                      onClick={() => downloadExcelData(selectedRowDataexcel)}
                      style={{ height: '18vh' }}
                    >
                      <img src={s2} style={{ width: '88%' }} />
                    </Button>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                    <Button
                      block
                      onClick={() => downloadExcelData2(selectedRowDataexcel)}
                      style={{ height: '18vh' }}
                    >
                      <img src={s1} style={{ width: '88%' }} />
                    </Button>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              ) : null}
              {valuee === 2 ? (
                <div>
                  <Stack direction="column" spacing={30}>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 LANDSCAPE IMAGES</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>1 LAND... & 1 PORT...</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
              {valuee === 3 ? (
                <div>
                  <Stack direction="column" spacing={30}>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>3 PORTRAIT IMAGES</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>PORTRAIT LAYOUT -1</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>3 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
            </Panel> */}
          </Drawer.Body>
        </Drawer>
      )}

      {/* PPT */}
      <Drawer size="xs" backdrop="static" open={open} onClose={() => setOpen(false)}>
        <Drawer.Header>
          <Drawer.Title>
            <b>Choose the desired format :</b>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            <FlexboxGrid justify="space-around">
              {slides.some(item => item.TempName == 'Format F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPPT1();
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_one} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F2') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPPT2();
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_two} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F3') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={() => handleDownloadPPT3()} className="pdf-layout">
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F4') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPPT4();
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_four} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F5') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={() => handleDownloadPPT5()} className="pdf-layout">
                    <img src={ppt_three} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format F6') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      handleDownloadPPT6();
                    }}
                    className="pdf-layout"
                  >
                    <img src={ppt_six} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format Two F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT7} className="pdf-layout">
                    <img src={ppt_seven} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format Three F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT8} className="pdf-layout">
                    <img src={ppt_eight} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
              {slides.some(item => item.TempName == 'Format Four F1') && (
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT9} className="pdf-layout">
                    <img src={ppt_nine} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </Panel>
          {/* <Panel>
            {value === 1 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '10px' }}>
                <Button block onClick={handleDownloadPPT1} style={{ height: '18vh' }}>
                <img src={s2} style={{ width: '88%' }} />
                </Button>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT2} style={{ height: '18vh' }}>
                    <img src={s1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '10px' }}>
                  <Button block onClick={handleDownloadPPT4} style={{ height: '18vh' }}>
                    <img src={s5} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT3} style={{ height: '18vh' }}>
                    <img src={s4} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT5} style={{ height: '18vh' }}>
                    <img src={s4} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT6} style={{ height: '18vh' }}>
                    <img src={s3} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {value === 2 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT8} style={{ height: '18vh' }}>
                    <img src={m5} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {value === 3 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT7} style={{ height: '18vh' }}>
                    <img src={t1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {value === 4 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT9} style={{ height: '18vh' }}>
                    <img src={f1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
          </Panel> */}
        </Drawer.Body>
      </Drawer>

      {/* PDF */}
      <Drawer size="xs" open={openp} onClose={handleClosep} backdrop="static">
        <Drawer.Header>
          <Drawer.Title>
            <b>Choose the desired format :</b>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            {slidespdf?.some(item => item.TempName == 'Format F1') && (
              <FlexboxGrid.Item
                as={Col}
                colspan={24}
                md={12}
                style={{ marginBottom: '10px' }}
                className="pdf-lyt"
              >
                <Button
                  block
                  onClick={() => {
                    handleDownloadPDF();
                  }}
                  className="pdf-layout"
                >
                  <img src={pdf_one} style={{ width: '88%' }} />
                </Button>
              </FlexboxGrid.Item>
            )}
            {slidespdf?.some(item => item.TempName == 'Format F2') && (
              <FlexboxGrid.Item
                as={Col}
                colspan={24}
                md={12}
                style={{ marginBottom: '10px' }}
                className="pdf-lyt"
              >
                <Button
                  block
                  onClick={() => {
                    handleDownloadPDF2();
                  }}
                  className="pdf-layout"
                >
                  <img src={pdf_two} style={{ width: '88%' }} />
                </Button>
              </FlexboxGrid.Item>
            )}
          </Panel>
          {/* <Panel>
            {valuep === 1 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPDF} style={{ height: '18vh' }}>
                    <img src={s1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPDF2} style={{ height: '18vh' }}>
                    <img src={s2} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {valuep === 2 ? (
              <div>
                <Stack direction="column" spacing={30}>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>2 LANDSCAPE IMAGES</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>2 PORTRAIT IMAGES</b>
                    </Stack>
                  </Stack>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>1 LAND... & 1 PORT...</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>2 PORTRAIT IMAGES</b>
                    </Stack>
                  </Stack>
                </Stack>
              </div>
            ) : null}
            {valuep === 3 ? (
              <div>
                <Stack direction="column" spacing={30}>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>3 PORTRAIT IMAGES</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>PORTRAIT LAYOUT -1</b>
                    </Stack>
                  </Stack>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>3 PORTRAIT IMAGES</b>
                    </Stack>
                  </Stack>
                </Stack>
              </div>
            ) : null}
          </Panel> */}
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default GenerateMarketing;
const readFileAsBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      resolve(event.target.result.split(',')[1]);
    };
    reader.onerror = error => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};
